import { fetch } from '@/common/request';

// 租户授权
export interface AgentTenantAuthVo {
  id: number;
  agentId: number;
  tenantMcid: string;
  dailyLimit?: number;
  monthlyLimit?: number;
  status?: number;
  authorizedBy?: string;
  authorizedAt?: string;
  updatedBy?: string;
  updatedAt?: string;
}

export interface TenantAuthReq {
  agentId: number;
  tenantMcid: string;
  dailyLimit?: number;
  monthlyLimit?: number;
  authorizedBy?: string;
}

export interface BatchAuthReq {
  agentId: number;
  tenantMcids: string[];
  dailyLimit?: number;
  monthlyLimit?: number;
  authorizedBy?: string;
}

export interface CancelAuthReq {
  agentId: number;
  tenantMcid: string;
}

export interface AuthListReq {
  agentId: number;
  tenantMcid?: string;
}

// 使用统计
export interface AgentUsageStatsVo {
  id: number;
  agentId: number;
  tenantMcid?: string;
  statDate: string;
  totalCalls: number;
  successCalls: number;
  failCalls: number;
  totalTokens?: number;
  avgLatencyMs?: number;
}

export interface UsageStatsReq {
  agentId: number;
  tenantMcid?: string;
  startDate?: string;
  endDate?: string;
}

export interface TenantAgentReq {
  tenantMcid: string;
}

export interface StatsOverviewVo {
  totalCalls: number;
  successRate: number;
  avgLatency: number;
  totalTokens: number;
}

// 租户授权 API
export function authorizeTenant(params: TenantAuthReq): Promise<number> {
  return fetch(
    '/api/config/agent/auth/authorize',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function batchAuthorize(params: BatchAuthReq): Promise<void> {
  return fetch(
    '/api/config/agent/auth/batchAuthorize',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function cancelAuth(params: CancelAuthReq): Promise<void> {
  return fetch(
    '/api/config/agent/auth/cancel',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function modifyAuth(params: TenantAuthReq): Promise<void> {
  return fetch(
    '/api/config/agent/auth/modify',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getAuthList(params: AuthListReq): Promise<AgentTenantAuthVo[]> {
  return fetch(
    '/api/config/agent/auth/list',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

// 使用统计 API
export function getUsageStatsList(params: UsageStatsReq): Promise<AgentUsageStatsVo[]> {
  return fetch(
    '/api/config/agent/usage/list',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getTodayOverview(params: UsageStatsReq): Promise<StatsOverviewVo> {
  return fetch(
    '/api/config/agent/usage/today',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getTenantStats(params: TenantAgentReq): Promise<AgentUsageStatsVo[]> {
  return fetch(
    '/api/config/agent/usage/tenant',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}